'use client';

import { isGetTheAppPath } from 'BomdisoftComponents/get-the-app/gate';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

export type GetTheAppFrameProps = {
  bare: ReactNode;
  children: ReactNode;
};

export const GetTheAppFrame = ({ bare, children }: GetTheAppFrameProps) => {
  const pathname = usePathname();
  return <>{isGetTheAppPath(pathname) ? bare : children}</>;
};
